import { render } from "./AnamneseVisualizar.vue?vue&type=template&id=29c42c2f"
import script from "./AnamneseVisualizar.vue?vue&type=script&lang=js"
export * from "./AnamneseVisualizar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__